import i18n from "../../plugins/I18nPlugin";

export function maxLengthRule(message = "objects.document.titleTooLong"): (value: any) => boolean | string {
  return (value) => {
    if (!value) return true;
    return value.length <= 256 || String(i18n.tc(message));
  };
}
